import cn from 'classnames';
import FeatherIcon from 'feather-icons-react';
import { useTranslation } from 'react-i18next';

import { Input } from 'components/FormComponents';

import styles from './SavedViewDrawerForm.module.scss';

export const VIEW_NAME_MAX_LENGTH = 50;

export const SavedViewDrawerForm = ({ filterPills, viewName, onViewNameChange, viewNameError }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.body}>
      {filterPills.length > 0 && (
        <div className={styles.appliedFilters}>
          <p className={styles.appliedFiltersLabel}>{t('reporting.appliedFilters')}</p>
          <div className={styles.pills}>
            {filterPills.map((pill, i) => (
              <div key={i} className={styles.pill}>
                <div className={styles.pillTitle}>
                  {pill.isDate && (
                    <FeatherIcon icon="calendar" size={14} className={styles.pillIcon} />
                  )}
                  <span>{pill.title}</span>
                </div>
                <div className={styles.pillValue}>
                  <span>{pill.value}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className={styles.fieldGroup}>
        <label className={styles.fieldLabel}>
          <span>
            {t('reporting.viewName')}
            <span className={styles.required}>*</span>
          </span>
          <span
            className={cn(styles.charCount, {
              [styles.charCountWarn]: viewName.length >= VIEW_NAME_MAX_LENGTH - 10,
            })}>
            {viewName.length}/{VIEW_NAME_MAX_LENGTH}
          </span>
        </label>
        <p className={styles.fieldHint}>{t('reporting.viewNameHint')}</p>
        <Input
          placeholder={t('reporting.viewNamePlaceholder')}
          error={viewNameError}
          maxLength={VIEW_NAME_MAX_LENGTH}
          inputProps={{
            value: viewName,
            onChange: onViewNameChange,
          }}
        />
      </div>
    </div>
  );
};
